export const statesApiProtertyName = {
  wait: 'en attente',
  incomplet: 'incomplet',
  accept: 'accepté',
  rejete: 'rejeté',
  correct: 'correction',
  termine: 'terminé',
};
